/**
 * GreenRouter UI color palette.
 */
export enum ThemeColors {
	// Light theme
	LightPrimary = "#1f3f58",
	LightPrimaryDark = "#152c3d",
	LightPrimaryLight = "#4b6579",

	LightSecondary = "#2b7772",
	LightSecondaryDark = "#1e534f",
	LightSecondaryLight = "#55928e",

	LightContrastText = "#FEFEFE",

	LightSuccess = "#388e3c",

	LightAction = "#6e6e6e",

	LightInfo = "#0288d1",
	LightWarning = "#ef6c00",
	LightError = "#d32f2f",

	LightBackground = "#F0F0F0",
	LightBackgroundTable = "#f3f3f3",
	LightBackgroundContrastText = "#000000",
	LightBackgroundElevation0 = "#F5F5F5",
	LightBackgroundElevation1 = "#FAFAFA",

	// Dark theme
	DarkPrimary = "#68E49A",
	DarkPrimaryDark = "#489F6B",
	DarkPrimaryLight = "#86E9AE",

	DarkSecondary = "#7A9EBF",
	DarkSecondaryDark = "#47749A",
	DarkSecondaryLight = "#BAD7F1",

	DarkContrastText = "#000000",

	DarkSuccess = "#2E7D32",

	DarkAction = "#FFFFFF",

	DarkInfo = "#0288D1",
	DarkWarning = "#EF6C00",
	DarkError = "#F44336",

	DarkBackground = "#0A0A0A",
	DarkBackgroundTable = "#f3f3f3",
	DarkBackgroundContrastText = "#FFFFFF",
	DarkBackgroundElevation0 = "#0F0F0F",
	DarkBackgroundElevation1 = "#141414",
}

/**
 * Application charts colors.
 */
export enum ChartColorValues {
	LightScope1Bar = "#4aad88",
	LightScope2Bar = "#4adbc8",
	LightScope3Bar = "#b39ddb",

	// @TODO
	DarkChartBar1 = "#F9A825",
	DarkScope1Bar = "#7EC5AB",
	DarkScope2Bar = "#4DD0E1",
	DarkScope3Bar = "#B39BDD",
}

export enum ActivityTypeColors {
	LightTransport = "#f9a825",
	LightOperativeUnits = "#f9dc5c",
	LightOther = "#845c38",

	// @TODO
	DarkTransport = "#F9A825",
	DarkOperativeUnits = "#7EC5AB",
	DarkOther = "#4DD0E1",
}

export enum TransportTypesColors {
	LightRoad = "#b39ddb",
	LightTrain = "#4aad88",
	LightShip = "#294c60",
	LightAir = "#f9a825",
	LightWaterWaves = "#299BDE",
	LightOther = "#845c38",

	// @TODO
	DarkRoad = "#b39ddb",
	DarkTrain = "#4aad88",
	DarkShip = "#294c60",
	DarkAir = "#f9a825",
	DarkWaterWaves = "#299BDE",
	DarkOther = "#845c38",
}

export enum EmissionsTypesColors {
	LightElectricity = "#f9dc5c",
	LightFuel = "#b39ddb",
	LightRefrigerant = "#4adbc8",
	LightHeat = "#f9a825",
	LightProcessGases = "#845c38",
	LightWater = "#4A86DB",

	// @TODO
	DarkElectricity = "#b39ddb",
	DarkFuel = "#4aad88",
	DarkRefrigerant = "#294c60",
	DarkHeat = "#f9a825",
	DarkProcessGases = "#f9a825",
	DarkWater = "#4A86DB",
}

export enum MethodsColors {
	Method1 = "#FFE066",
	Method2 = "#CBA3FF",
	Method3 = "#5DE6D1",
	Method4 = "#FFB347",
	Method5 = "#A67C52",
	Method6 = "#5CA8FF",

	// @TODO
	DarkMethod1 = "#FFE066",
	DarkMethod2 = "#CBA3FF",
	DarkMethod3 = "#5DE6D1",
	DarkMethod4 = "#FFB347",
	DarkMethod5 = "#A67C52",
	DarkMethod6 = "#5CA8FF",
}

/**
 * Chart colors configuration.
 */
export type ChartColorsConfiguration = {
	scope1Bar: string;
	scope2Bar: string;
	scope3Bar: string;
	roadType: string;
	trainType: string;
	shipType: string;
	airType: string;
	electricityType: string;
	fuelType: string;
	refrigerantType: string;
	heatType: string;
	processGasesType: string;
	transportType: string;
	operativeUnitsType: string;
	otherType: string;
	method1: string;
	method2: string;
	method3: string;
	method4: string;
	method5: string;
	method6: string;
};

/**
 * Application map colors
 */
export enum MapColorValues {
	LightTransportRoad = "#F9A825",
	LightTransportRail = "#7EC5AB",
	LightTransportSea = "#4DD0E1",
	LightTransportAir = "#B39BDD",

	DarkTransportRoad = "#F9A825",
	DarkTransportRail = "#7EC5AB",
	DarkTransportSea = "#4DD0E1",
	DarkTransportAir = "#B39BDD",
}

/**
 * Chart colors configuration.
 */
export type MapColorsConfiguration = {
	transportRoad: string;
	transportRail: string;
	transportSea: string;
	transportAir: string;
};

/**
 * GreenRouter UI shapes preferences.
 */
export enum ThemeShapes {
	CardBorderRadius = 10,
	ShapeBorderRadius = 5,
}

/**
 * GreenRouter UI common padding values used in theme builder.
 */
export enum ThemePadding {
	Px10 = 10,
}
